export default __webpack_public_path__ + "static/media/895.0179a013.png";